import {
    CheckCircle2,
    XCircle,
    Ban,
    RotateCcw,
} from "lucide-react";

import {
    approveDeliveryPartner,
    rejectDeliveryPartner,
    suspendDeliveryPartner,
    activateDeliveryPartner,
} from "../../services/adminApi";

import "./DeliveryActionButtons.css";

function DeliveryActionButtons({
    partner,
    reload,
}) {

    const updateStatus = async (action) => {

        try {

            switch (action) {

                case "approve":
                    await approveDeliveryPartner(partner._id);
                    break;

                case "reject":
                    await rejectDeliveryPartner(partner._id);
                    break;

                case "suspend":
                    await suspendDeliveryPartner(partner._id);
                    break;

                case "activate":
                    await activateDeliveryPartner(partner._id);
                    break;

                default:
                    return;

            }

            reload();

        } catch (error) {

            console.error(error);

            alert("Something went wrong.");

        }

    };

    return (

        <div className="delivery-actions-card">

            <h3>Partner Actions</h3>

            <div className="actions-grid">

                <button
                    className="approve-btn"
                    onClick={() => updateStatus("approve")}
                >
                    <CheckCircle2 size={18} />
                    Approve
                </button>

                <button
                    className="reject-btn"
                    onClick={() => updateStatus("reject")}
                >
                    <XCircle size={18} />
                    Reject
                </button>

                <button
                    className="suspend-btn"
                    onClick={() => updateStatus("suspend")}
                >
                    <Ban size={18} />
                    Suspend
                </button>

                <button
                    className="activate-btn"
                    onClick={() => updateStatus("activate")}
                >
                    <RotateCcw size={18} />
                    Activate
                </button>

            </div>

        </div>

    );

}

export default DeliveryActionButtons;